import { render } from "./ProductUpdateForm.vue?vue&type=template&id=d912b362&scoped=true"
import script from "./ProductUpdateForm.vue?vue&type=script&lang=js"
export * from "./ProductUpdateForm.vue?vue&type=script&lang=js"

import "./ProductUpdateForm.vue?vue&type=style&index=0&id=d912b362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d912b362"]])

export default __exports__